import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import demoGif from "../Assets/demo.gif";
import azureimg from "../Assets/azure.png";
import awsimg from "../Assets/aws.png";
import gcpimg from "../Assets/gcp.png";

const cloudProviders = [
  {
    name: "AWS Cloud",
    image: awsimg,
  },
  {
    name: "GCP Cloud",
    image: gcpimg,
  },
  {
    name: "Azure Cloud",
    image: azureimg,
  },
];

const ByocSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % cloudProviders.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-white p-6 md:p-10 py-16  border-t border-b border-gray-400">
      <div className="text-center mb-16">
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="inline-flex flex-col items-center justify-center gap-2"
        >
          <p className="bg-yellow-50 text-yellow-600 font-semibold text-sm md:text-base px-4 py-1 rounded-full border border-yellow-300 shadow-sm uppercase tracking-wider">
            BYOC
          </p>

          <motion.div
            className="text-2xl md:text-3xl  font-bold "
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.6, ease: "easeOut" }}
          >
            <p>Bring Your Own Cloud </p>
          </motion.div>
        </motion.div>
      </div>

      <div className="flex flex-col lg:flex-row items-center justify-between gap-10 w-full">
        {/* Left Content */}
        <div className="w-full lg:w-1/2">
          <p className="text-3xl font-bold">Bring Your</p>
          <div className="flex items-center gap-2 mt-2">
            {/* <motion.p
            key={index}
            className="mt-4 text-2xl font-semibold text-yellow-600"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5 }}
          >
            {cloudProviders[index].name}
          </motion.p> */}
            <motion.img
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.5 }}
              src={cloudProviders[index].image}
              alt={`${cloudProviders[index].name} logo`}
              className=" h-8 object-contain"
            />
          </div>
          <p className="mt-6 text-gray-700">
            Connect your existing cloud in minutes. Use efficientAI's control
            plane to seamlessly orchestrate your LLM workloads, while keeping
            your data plane secure within your own cloud environment.
          </p>
        </div>

        <motion.div
          className="w-full lg:w-[60%] h-auto max-h-[400px] bg-gray-100 flex items-center justify-center rounded-2xl overflow-hidden"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <img
            src={demoGif}
            alt="BYOC in action"
            className="w-full h-full object-contain"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default ByocSection;
